import * as React from 'react'
import Utils from '../../helper/utils';

export const Forbidden = () => {
    Utils.setDocumentTitle("Acesso proibido");
    document.body.style.backgroundColor ='#ffffff';
    const wait = () => {setTimeout(sai, 2500)};

    function sai(){
        Response.redirect("/")
    }
     return (
        
         <div>
            <img src='/AcessoNegado.jpg' alt='Acesso proibido' />        
        </div>
     )
}

 